<script>
  import {getContext} from 'svelte';
  import {LINKS} from '@/const';
  import {timeUtil} from '@/helper/time';
  import {sd} from '@/da';
  import {fixLink$} from '@/store/lang';
  import {announcements$} from './stream';
  import lang from '../../Header.lang';

  const LG = getContext('LG');

  function handleAnnouncementClick(item) {
    return function () {
      sd.track('web_click', {$screen_name: 'home', $element_content: 'announcement_' + item.detail.title});
    };
  }
</script>

<style>
  .wrap {
    box-sizing: border-box;
    padding: 16px 12px;
    width: 460px;
    background: rgba(26, 29, 31, 0.96);
    backdrop-filter: blur(10px);
    cursor: default;
    overflow: hidden;
    box-shadow: 0 0 20px 0 rgba(204, 204, 204, 0.4);
  }
  .circle {
    display: inline-block;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background: #38d102;
  }
  .body {
    height: 306px;
    overflow: hidden auto;
  }
  .all {
    border-bottom: 1px solid #454952;
    padding-bottom: 16px;
  }
  .content {
    margin-top: 4px;
    padding: 0;
    font-size: 12px;
    white-space: normal;
    opacity: .8;
  }
  .item {
    box-sizing: border-box;
    padding: 12px 8px;
  }
  .item:hover {
    border-radius: 8px;
    background: #333333;
  }
  .announce-con {
    width: 320px;
  }
  .announce {
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    color: #B0B2B8;
  }
  .all-icon a {
    color: #fff;
  }
</style>

<div class="wrap TW">
  <div class="all df fdr jcsb lh24 TW f14 fw1">
    <div class="notice-title df aic ooo">
      <i class="iconfont f24">&#xe74c;</i>
      <span class="ooo ml8 fw3">{LG(lang.RecentTrading)}</span>
    </div>
    <div class="all-icon df aic cp">
      <a href={$fixLink$(LINKS.PHEMEX_REFERENCES_ANNOUNCEMENTS, 'CMS')} target="_blank" rel="noopener noreferrer nofollow">
        {LG(lang.All)}<i class="iconfont ml4 f16">&#xe761;</i>
      </a>
    </div>
  </div>

  <div class="body mt8 sv">
    {#each $announcements$ || [] as item (item.id)}
      <div class="item df aic">
        <span class="circle mr12" />
        <a class="announce-con" href={item.detail.webLink} on:click={handleAnnouncementClick(item)}>
          <div class="announce f14 lh24 fw2 T2">{item.detail.title}</div>
          {#if item.detail.content}
            <div class="announce content lh18 fw1">{@html item.detail.content}</div>
          {/if}
        </a>
        <div class="f12 fw1 lh18 ml8" style="margin-left:auto;color: #B0B2B8;">{timeUtil.formatDate(item.releaseTime)}</div>
      </div>
    {/each}
  </div>
</div>
